const moment = require('moment');

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return 'iOS';

    }
    else if (userAgent.match(/Android/i)) {

        return 'Android';
    }
    else {
        return 'unknown';
    }
}

//Handle pressing back button for application
if (getMobileOperatingSystem() == "iOS") {
    window.addEventListener('popstate', function () {
        // If fresh page is false that means it is a cached page, remove html and reload page.
        if (!freshPage) {
            if (window.location.pathname.toLowerCase().indexOf("/application/step") >= 0) {
                $('html').remove();
                window.location = "/";
            }
        } else {
            freshPage = false;
        }
    });

}

var idleTime = 0;
var sixtySecondTimer = 61;

function resetTimer() {
    idleTime = 0;
    sixtySecondTimer = 61;
    $.get('/Ping', function () { });
}

$('#dismiss-timeout-modal').click(function () {
    $('#timeout-modal').modal('hide');
    resetTimer();
});

$('#x-timeout-modal').click(function () {
    $('#timeout-modal').modal('hide');
    resetTimer();
});

$(document).ready(function () {
    if (window.location.pathname.toLowerCase().indexOf("/application/step") >= 0) {
        //Timeouts
        //Increment the idle time counter every minute.
        var idleInterval = setInterval(timerIncrement, 1000); // 1 second

        //Zero the idle timer on interaction.
        $("input, select").focus(function () {
            resetTimer();
        });

        window.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && $('#timeout-modal').is(':visible')) {
                $('#timeout-modal').modal('hide');
                resetTimer();
            }
        });
    }

    // FSFALLYP1-138: brute forcing all of the first name to be first letter capitalized no matter how many first names there are
    // -- tied to step 2 of application, <span id="capitalize"> is the targeted element
    if ($('#capitalize').length) {
        var str = $('#capitalize').innerText;
        // -- get all the words listed, capitalize first letter
        const newStr = str.split(' ')
            .map(w => w[0].toUpperCase() + w.substring(1).toLowerCase())
            .join(' ');
        // -- replace directly on page
        $('#capitalize').innerText = newStr;
    }

    if ($('#MonthlyRentOrMortgagePayment').length) {
        var validator = $('form').data('validator');

        var oldErrorFunction = function () { };
        var oldSuccessFunction = function () { };

        if (validator.settings !== undefined) {
            if (validator.settings.errorPlacement !== undefined) {
                oldErrorFunction = validator.settings.errorPlacement;
            }

            if (validator.settings.success !== undefined) {
                oldSuccessFunction = validator.settings.success;
            }
        }

        validator.settings.errorPlacement = function (error, element) {
            if ($(element).hasClass('input-validation-alert')) {
                $(element).removeClass('input-validation-alert');
                $(element).siblings('.field-validation-error').removeClass('field-validation-alert');
            }

            oldErrorFunction(error, element);

            if (error.text() == annualIncomeWarning || error.text() == monthlyPaymentWarning) {
                $(element).addClass('input-validation-alert');
                $(element).siblings('.field-validation-error').addClass('field-validation-alert');
            }
        };

        validator.settings.success = function (label, element) {
            if ($(element).hasClass('input-validation-alert')) {
                $(element).removeClass('input-validation-alert');
                $(element).siblings('.field-validation-error').removeClass('field-validation-alert');
            }

            oldSuccessFunction(label, element);
        };

        if ($('.totalAnnualIncome').val() !== '') {
            $('.totalAnnualIncome').blur();
        }

        if ($('.rentMortgagePayment').val() !== '') {
            $('.rentMortgagePayment').blur();
        }

        $("form").bind("invalid-form.validate", function () {
            $('.ignore-validation').removeClass('ignore-validation');
            $('input').blur();
        });
    }

    //initiate fraudnet
    if (typeof tbreb !== 'undefined') {
        tbreb.tkreb(null);
    }
});

var annualIncomeWarning = 'Please check that your total annual income is correct.';
var monthlyPaymentWarning = 'Please check that your monthly payment is correct.';

$.validator.setDefaults({
    ignore: "#CountryOfCitizenship:hidden, #AreYouMarried:hidden, input[name='TermsAndConditions']:hidden"
});

$("#button-back").click(function () {
    resetTimer();
});

$(".jsCancel").click(function (e) {
    e.preventDefault();
    $(e.currentTarget).closest("form").validate().settings.ignore = "*";
    window.location.href = $(this).attr("href");
});

function timerIncrement() {
    idleTime = idleTime + 1;
    if (idleTime > 840 || $('#timeout-modal').is(':visible')) { // 14 minutes // set to 3 minutes for testing purposes
        $('#timeout-modal').modal('show');
        sixtySecondTimer -= 1;
        $('#timeout-counter').text(sixtySecondTimer);
    }

    // If timer = 0, redirect for session abandomment
    if (sixtySecondTimer == 0) {
        window.location = "/Application/ProcessTimeout";
        return;
    }

    $('#seconds-left-to-timeout').text(sixtySecondTimer);
}

$('#app-form-step1').on("submit", function (e) {
    if (IsFormValid('#app-form-step1')) {
        $(':submit', this).attr('disabled', 'disabled');
    }
});

$('#app-form-step2').on("submit", function (e) {
    if (IsFormValid('#app-form-step2')) {
        $(':submit', this).attr('disabled', 'disabled');
    }
});

$('#app-form-step4').on("submit", function (e) {
    e.preventDefault();

    //validate entire form
    if (!IsFormValid('#app-form-step4'))
    {
        return;
    }

    $(':submit', this).attr('disabled', 'disabled');

    //fraudnet submit handler
    if (typeof tbreb !== 'undefined') {
        tbreb.tbreby('jtbreb');
    }

    // FSFALLYP1-140 (adding modal to overlay visible content - no longer need to hide)
    /*$("*[id*=section-]:visible").hide();*/
    /*$("*[id*=button-]").hide();*/

    // Static modal pops up while loading application decision
    $("#section-loading").modal();

    //Frontend check for invalid form fields
    var dataArray = $('#app-form-step4').serializeArray(),
    dataObj = {};

    $(dataArray).each(function (i, field) {
        dataObj[field.name] = field.value;
    });

    var errorFields = "";
    $("[data-val-required]").each(function (i, field) {
        if (this.name != "AreYouMarried" && this.name != "CountryOfCitizenship") {
            if (dataObj[this.name] == null || dataObj[this.name] == "") {
                errorFields += this.name + "_";
            }
        }
    });

    if (errorFields) {
        window.location = "/Application/Error?e=" + encodeURIComponent(errorFields);
        return;
    }

    if (window.DY && DY.API) {
        DY.API("event", {
            name: "Submission",
            properties: {
                uniqueTransactionId: dyRac,
                dyType: "purchase-v1",
                value: 1.00,
                currency: "USD",
                cart: [
                    {
                        productId: dyProductSku,
                        quantity: 1,
                        itemPrice: 100.00,
                    }
                ]
            },
        });
    }

    $.ajax({
        url: "/Application",
        type: "POST",
        data: $(this).serialize(),
        success: function (data) {
            if (data.result == 'Redirect') {
                window.location = data.url;
            } else {
                window.location = "/Application/Error?e=cdata";
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            window.location = "/Application/Error?e=" + encodeURIComponent(errorThrown);
        },
        timeout: 60000
    });
});

// extend range validator method to treat checkboxes differently
var defaultRangeValidator = $.validator.methods.range;
$.validator.methods.range = function (value, element, param) {
    if (element.type === 'checkbox') {
        // if it's a checkbox return true if it is checked
        return element.checked;
    } else {
        // otherwise run the default validation function
        return defaultRangeValidator.call(this, value, element, param);
    }
}

//Hide/Show Questions based on others
$('input[type=radio][name=AreYouACitizen]').change(function () {
    if (this.value == "True") {
        $('#countrysection').hide();
    }
    else if (this.value == "False") {
        $('#countrysection').show();
    }
});

function IsFormValid(formId) {
    var validator = $(formId).validate();

    var valid = true;
    var firstInvalidField = null;

    var selector = [formId, ' input, ', formId, ' select'].join('');

    $(selector).each(function (i, v) {
        valid = validator.element(v) && valid;
        if (!valid && firstInvalidField == null) {
            firstInvalidField = v;
        }
    });

    if(!valid){
        $(firstInvalidField).focus();
    }

    return valid;
}

//Custom validation for checking 18 years old
function getAge(dateString) {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

$.validator.addMethod("validateDate", function (value, element) {
    return this.optional(element) || (moment(value, 'MM/DD/YYYY', true).isValid() && getAge(value) <= 120);
}, "Please enter a valid date of birth.");

$.validator.addMethod("agecheck", function (value, element) {
    return this.optional(element) || getAge(value) >= 18;
}, "You must be 18 or older to apply.");

$.validator.addMethod("ssncheck", function (value, element) {
    return this.optional(element) || ssnregex.test(value);
}, "Please enter a valid social security number.");

//Check address1 and address2 for valid inputs
$.validator.addMethod("addressvalidation", function (value, element) {
    return this.optional(element) || /^([a-zA-Z\d #\.-]+)$/.test(value);
}, "Please enter a valid address.")

//Check address1 and address2 for P.O.Box
$.validator.addMethod("poboxcheck", function (value, element) {
    return this.optional(element) || !/[pP][^a-zA-Z\d]*[oO][^a-zA-Z\d]*[bB][^a-zA-Z\d]*[oO][^a-zA-Z\d]*[xX]/.test(value);
}, "We can't process your application with a PO Box or APO Address. Please enter a street address.");

//$.validator.addMethod("apocheck", function (value, element) {
//    return this.optional(element) || !/[aA][^a-zA-Z\d]*[pP][^a-zA-Z\d]*[oO]/.test(value);
//}, "We can't process your application with a PO Box or APO Address. Please enter a street address.")

$.validator.addClassRules({
    dob: {validateDate:true, agecheck: true},
    ssn: { ssncheck: true },
    address1: { addressvalidation: true, poboxcheck: true},
    address2: { addressvalidation: true, poboxcheck: true },
    totalAnnualIncome: { aboveminvalue: { minvalue: 10000 } },
    rentMortgagePayment: { belowmaxvalue: { maxvalue: 10000 } }
});

//Fixes strange issue with keyup for Home Phone validation triggering early
$.validator.setDefaults({
    onkeyup: function () {
        var originalKeyUp = $.validator.defaults.onkeyup;
        var customKeyUp = function (element, event) {
            if ($("#HomePhone")[0] === element && $("#HomePhone").val().length < 14) {
                return false;
            }
            else {
                return originalKeyUp.call(this, element, event);
            }
        }

        return customKeyUp;
    }(),
    onfocusout: function () {
        var originalFocusOut = $.validator.defaults.onfocusout;
        var customFocusOut = function (element, event) {
            if ($("#HomePhone")[0] === element && $("#HomePhone").val().length == 0) {
                $("#HomePhone").addClass("valid");
                if ($("#HomePhone").hasClass("input-validation-error")) {
                    $("#HomePhone").removeClass("input-validation-error");
                }
                $("span[data-valmsg-for='HomePhone']").empty();
                return false;
            }
            else {
                return originalFocusOut.call(this, element, event);
            }
        }

        return customFocusOut;
    }()
});

$(document).keyup(function (e) {
    var code = e.keyCode || e.which;
    if ((code == '9' || code == '16') && $("#HomePhone").length) {
        if ($("#HomePhone").val().length == 0 && !$("#HomePhone").hasClass("valid")) {
            $("#HomePhone").addClass("valid");
            if ($("#HomePhone").hasClass("input-validation-error")) {
                $("#HomePhone").removeClass("input-validation-error");
            }
            $("span[data-valmsg-for='HomePhone']").empty();
        }
    }
});

$("select[name=State]").change(function () {
    if (this.value == "WI") {
        $('#marriedsection').show();
    }
    else {
        $('#marriedsection').hide();
    }
});

//Hide/Show Tooltips
//$('.tooltip-toggle').click(function (event) {
//    $(".tooltip-text:visible").hide();
//    $(this).siblings(".tooltip-text").show();
//    event.stopPropagation();
//});
//$(window).click(function () {
//    $(".tooltip-text:visible").hide();
//});

//$('.tooltip-toggle').focus(function () {
//    $(this).siblings(".tooltip-text").show();
//});
//$('.tooltip-toggle').blur(function () {
//    $(this).siblings(".tooltip-text").hide();
//});


// Bootstrap tooltip (actually called popover in this circumstance because it is not triggered on hover, which a tooltip is) is not turned "on" by default, so manually initializing 
$("[data-toggle=popover]").popover({ trigger: 'focus' });


//Input masks
$('.dob').mask('00/00/0000');
$("#SSN").mask("000-00-0000");
$("#offerCode").mask("000AA-AA000ZZ", {
    translation: {
        'A': { pattern: /[a-zA-Z0-9]/ }, 
        'Z': { pattern: /[0-9]/, optional: true }
    }
});
$('.phone').mask('(000) 000-0000');
$('.rentMortgagePayment').mask('00,000', {reverse: true});
$('.totalAnnualIncome').mask('000,000', { reverse: true });

if (getMobileOperatingSystem() == "Android") { //Handling for strange input mask issue.
    $("#SSN").attr("type", "tel");
    $("#DOB").attr("type", "tel");
    $("#MonthlyRentOrMortgagePayment").attr("type", "tel");
    $("#TotalAnnualIncome").attr("type", "tel");
}

//clicking validation error sets focus to its input
$('form').bind('click', function (event) {
    if ($(event.target).parent().attr('data-valmsg-for')) {
        $("#" + $(event.target).parent().attr('data-valmsg-for')).focus();
    }
});

$('#app-form-step3').submit(function (e) {
    $('.totalAnnualIncome').addClass('ignore-validation');
    $('.rentMortgagePayment').addClass('ignore-validation');

    ////validate entire form
    if (!IsFormValid('#app-form-step3')) {
        $('.totalAnnualIncome').removeClass('ignore-validation');
        $('.rentMortgagePayment').removeClass('ignore-validation');
        return false;
    }

    $(':submit', this).attr('disabled', 'disabled');
    //$('#app-form-step3').submit();
    return true;
});

$.validator.addMethod("aboveminvalue", function (value, element, params) {
    if ($(element).hasClass('ignore-validation')) {
        return true;
    }

    var cleanValue = value.replace(',', '');
    if (cleanValue === '') {
        return true;
    }

    var val = parseInt(cleanValue);

    if (isNaN(val) || val == 0) {
        return true;
    }

    return val >= params.minvalue;
}, annualIncomeWarning);


$.validator.addMethod("belowmaxvalue", function (value, element, params) {
    if ($(element).hasClass('ignore-validation')) {
        return true;
    }

    var cleanValue = value.replace(',', '');
    if (cleanValue === '') {
        return true;
    }

    var val = parseInt(cleanValue);
    if (isNaN(val)) {
        return true;
    }

    return val < params.maxvalue;
}, monthlyPaymentWarning);


const NAVIGATION_PROGRESS_BAR = document.querySelector('#dy-main-container-steps > .dy-progress-bar-blue');

function waitForElement(elementID) {
    DYO.waitForElementAsync(elementID)
        .then(([element]) => {
            element.classList.add('dy-invisible');
        });
}

function createSelectorDesctop(section) {
    return '.d-none.d-lg-block.col-lg-6.col-sm-12.progress-bar.px-0.bg-white.section-'
        + section
        + ':has(li.list-group-item.text-nowrap.px-2)';
}

function createSelectorMobile(section) {
    return '.d-block.d-lg-none.px-0.progress-bar.bg-white.section-'
        + section
        + ':has(li.list-group-item.text-nowrap.px-1)';
}

function hideElement(text) {
    const mobileSelector = createSelectorDesctop(text);
    const desctopSelector = createSelectorMobile(text);
    waitForElement(mobileSelector);
    waitForElement(desctopSelector);
}

function changeProgressBarWidth() {
    const currentLink = window.location.href;
    switch (true) {
        case currentLink.toLowerCase().includes('/step1'):
            hideElement('welcome');
            NAVIGATION_PROGRESS_BAR.classList.add('dy-progress-25');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-50');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-75');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-100');
            break;
        case currentLink.toLowerCase().includes('/step2'):
            hideElement('contact');

            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-25');
            NAVIGATION_PROGRESS_BAR.classList.add('dy-progress-50');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-75');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-100');
            break;
        case currentLink.toLowerCase().includes('/step3'):
            hideElement('finance');

            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-25');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-50');
            NAVIGATION_PROGRESS_BAR.classList.add('dy-progress-75');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-100');
            break;
        case currentLink.toLowerCase().includes('/step4'):
            hideElement('security');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-25');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-50');
            NAVIGATION_PROGRESS_BAR.classList.remove('dy-progress-75');
            NAVIGATION_PROGRESS_BAR.classList.add('dy-progress-100');
            break;
    }
}

function detectLink() {
    window.addEventListener('load', () => {
        changeProgressBarWidth();
    });
}

changeProgressBarWidth();
detectLink();